var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.temPerguntas
    ? _c(
        "div",
        _vm._b(
          { staticClass: "manager-questions ia-block-card" },
          "div",
          _vm.MOLDURA_DO_THREAD,
          false
        ),
        [
          _c(
            _vm.editavel ? "div" : "button",
            {
              tag: "component",
              staticClass:
                "ia-block-card__cabecalho ia-block-card__cabecalho--fita",
              class: _vm.classeCabecalho,
              attrs: {
                type: _vm.editavel ? null : "button",
                "aria-expanded": _vm.editavel ? null : String(_vm.reaberto)
              },
              on: { click: _vm.alternar }
            },
            [
              _c("icon-svg", {
                staticClass: "ia-block-card__icone",
                attrs: { name: "question", size: 14, color: "var(--primary)" }
              }),
              _c("span", { staticClass: "ia-block-card__titulo" }, [
                _vm._v(_vm._s(_vm.titulo))
              ]),
              _c("span", { staticClass: "ia-block-card__meta" }, [
                _vm._v(_vm._s(_vm.legendaDaFita))
              ]),
              !_vm.editavel
                ? _c("icon-svg", {
                    staticClass: "ia-block-seta",
                    class: _vm.classeSeta,
                    attrs: {
                      name: "arrow-down-new-ux",
                      size: 14,
                      color: "var(--neutral-700)"
                    }
                  })
                : _vm._e()
            ],
            1
          ),
          _vm._l(_vm.itens, function(item) {
            return _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.mostraCorpo,
                    expression: "mostraCorpo"
                  }
                ],
                key: item.chave,
                staticClass: "manager-questions__item"
              },
              [
                _c(
                  "span",
                  { staticClass: "manager-questions__corpo" },
                  [
                    _c(
                      "label",
                      {
                        staticClass:
                          "manager-questions__pergunta ia-texto-auxiliar",
                        attrs: { for: item.chave }
                      },
                      [_vm._v(" " + _vm._s(item.pergunta) + " ")]
                    ),
                    item.porque
                      ? _c(
                          "span",
                          {
                            staticClass:
                              "manager-questions__porque ia-texto-auxiliar"
                          },
                          [_vm._v(" " + _vm._s(item.porque) + " ")]
                        )
                      : _vm._e(),
                    item.enviada
                      ? _c(
                          "span",
                          {
                            staticClass:
                              "manager-questions__resposta ia-texto-auxiliar"
                          },
                          [_vm._v(" " + _vm._s(item.enviada) + " ")]
                        )
                      : _vm.respondido
                      ? _c(
                          "span",
                          {
                            staticClass:
                              "manager-questions__sem-resposta ia-texto-auxiliar"
                          },
                          [_vm._v(" " + _vm._s(_vm.semResposta) + " ")]
                        )
                      : _vm._e(),
                    _vm.editavel
                      ? _c("v-textarea", {
                          staticClass: "manager-questions__campo no-border",
                          attrs: {
                            id: item.chave,
                            value: _vm.respostas[item.indice] || "",
                            placeholder: _vm.placeholder,
                            rows: "1",
                            "auto-grow": "",
                            "hide-details": "",
                            dense: "",
                            disabled: _vm.enviando
                          },
                          on: {
                            input: function($event) {
                              return _vm.aoDigitar(item.indice, $event)
                            }
                          }
                        })
                      : _vm._e()
                  ],
                  1
                )
              ]
            )
          }),
          _vm.editavel
            ? _c(
                "div",
                { staticClass: "manager-questions__acoes" },
                [
                  _c(
                    "BaseButton",
                    {
                      attrs: {
                        primary: "",
                        disabled: !_vm.podeEnviar,
                        loading: _vm.enviando
                      },
                      on: { click: _vm.enviar }
                    },
                    [_vm._v(" " + _vm._s(_vm.rotuloEnvio) + " ")]
                  )
                ],
                1
              )
            : _vm._e()
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }